export class Organisation {
    org_adresse: string;
    org_email: string;
    org_id: string;
    org_libelle: string;
    org_pays: string;
    org_tel: string;
    org_url: string;


    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.org_id                  = data['org_id'] ? data['org_id'] : null;
        this.org_libelle             = data['org_libelle'] ? data['org_libelle'] : null;
        this.org_pays                = data['org_pays'] ? data['org_pays'] : null;
        this.org_adresse             = data['org_adresse'] ? data['org_adresse'] : null;
        this.org_email               = data['org_email'] ? data['org_email'] : null;
        this.org_tel                 = data['org_tel'] ? data['org_tel'] : null;
        this.org_url                 = data['org_url'] ? data['org_url'] : null;
    }
}
